import React, { Fragment } from "react";

class Button2 extends React.Component {
  render() {
    return (
      <Fragment>
        <div className="text-center p-5">
          <a href="https://tangled.ae/Spellbound-Robot/entry.php?val=2">
            <button type="button" className="btn-lg btn-success">
              Left
            </button>
          </a>
        </div>
      </Fragment>
    );
  }
}

export default Button2;
